import { render, staticRenderFns } from "./InviteStep.vue?vue&type=template&id=71855734"
import script from "./InviteStep.vue?vue&type=script&lang=js"
export * from "./InviteStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports